var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Profile"},[(_vm.Header)?_c('HeaderVisor'):_vm._e(),_c('Header'),_c('section',{staticClass:"containerPpal"},[_c('Profile')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }